import { thousandSeparator, decimalSeparator } from '../constants/formatSeparator';

const limitToDot = 5;
const every3CharsRegex = /\B(?=(\d{3})+(?!\d))/g;

export const formatCurrency = (inputValue: number | string | undefined) => {
  if (!inputValue) return '';

  const asString = typeof inputValue === 'number' ? inputValue.toString().replace('.', decimalSeparator) : inputValue;

  const re = new RegExp(String.raw`[^0-9${decimalSeparator}]`, 'g');
  let formattedValue = asString.replace(re, '');

  if (formattedValue.includes(decimalSeparator)) {
    let [integerPart, decimalPart] = formattedValue.split(decimalSeparator);
    decimalPart = decimalPart.replace(/[^0-9]/g, '');
    formattedValue = `${integerPart}${decimalSeparator}${decimalPart}`;
  }

  const digitCount = formattedValue.includes(decimalSeparator)
    ? formattedValue.split(decimalSeparator)[0].length
    : formattedValue.length;

  if (digitCount >= limitToDot) {
    const [integerPart, decimalPart] = formattedValue.split(decimalSeparator);
    const formattedInteger = integerPart.replace(every3CharsRegex, thousandSeparator);
    formattedValue =
      decimalPart !== undefined ? `${formattedInteger}${decimalSeparator}${decimalPart}` : formattedInteger;
  }

  return formattedValue;
};

export function parseLocaleNumber(stringNumber: string | null) {
  if (!stringNumber) {
    return null;
  }

  return parseFloat(
    stringNumber
      .replace(new RegExp('\\' + thousandSeparator, 'g'), '')
      .replace(new RegExp('\\' + decimalSeparator), '.')
      .replace(/\s/g, '')
  );
}
